import { debounce } from '@gem/utils';

import { subscribeUpdateMessages } from 'APP/model/message/messageModel';
import Entities from 'STORE';
import { IViewportMessagesData } from 'STORE/ViewportMessages/ViewportMessages';

const SUBSCRIBE_MESSAGE_DEBOUNCE = 250;

class MessageUpdateService {
  private static instance: MessageUpdateService;

  public static getInstance(): MessageUpdateService {
    if (!MessageUpdateService.instance) {
      MessageUpdateService.instance = new MessageUpdateService();
    }
    return MessageUpdateService.instance;
  }

  public subscribeDebounce: (data: IViewportMessagesData[]) => void;

  private prevMessageData: IViewportMessagesData[] = [];

  constructor() {
    this.subscribeDebounce = debounce((data) => this.subscribe(data), SUBSCRIBE_MESSAGE_DEBOUNCE);
  }

  private async subscribe(data: IViewportMessagesData[]): Promise<void> {
    if (this.isSameMessageData(data, this.prevMessageData)) {
      return;
    }
    this.prevMessageData = data;

    await subscribeUpdateMessages(data);
  }

  private isSameMessageData(
    current: IViewportMessagesData[],
    prev: IViewportMessagesData[]
  ): boolean {
    if (current.length !== prev.length) {
      return false;
    }
    return current.every(({ messageId, groupId }) =>
      prev.some((item) => item.messageId === messageId && item.groupId === groupId)
    );
  }
}

export function updateMessagesInViewport(): void {
  const messages = Entities.viewportMessages.viewportMessages;

  MessageUpdateService.getInstance().subscribeDebounce(messages);
}
